module.exports = __webpack_public_path__ + "icofont.00e93fdfb6da9c1e4c4b.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/icofont.svg?v=1.0.0-beta
// module id = ../../../../../src/assets/fonts/icofont.svg?v=1.0.0-beta
// module chunks = styles